import * as React from 'react';
import { Button, classNames, target, safeValue } from './cta-button/helpers';
import { detectUserState } from './cta-button/api';
import Link from './cta-button/components/Link';

export default function (props) {
  const {
    button_variant: variant = Button.Variant.primary,
    button_size: size = Button.Size.medium,
    program_id: programID = null,
    logged_out_text: loggedOutText = 'Log In',
    logged_out_url: loggedOutUrl = '',
    logged_in_non_member_text: loggedInNonMemberText = 'Join',
    logged_in_non_member_url: loggedInNonMemberUrl = '',
    logged_in_text: loggedInText = 'Member Area',
    logged_in_url: loggedInUrl = '',
    open_in_new_tab: openInNewTab = false,
  } = props;

  const [userState, setUserState] = React.useState(Button.State.unknown);
  const [linkText, setLinkText] = React.useState();
  const [linkUrl, setLinkUrl] = React.useState();

  React.useEffect(() => {
    let abortController = new AbortController();

    detectUserState(programID, abortController)
      .then(data => {
        const { state } = data;
        setUserState(state);
      })
      .catch(error => {
        console.log(error);
        setUserState(Button.State.unknown);
      });

    return () => {
      abortController.abort();
    }
  }, [programID, loggedOutText, loggedInNonMemberText, loggedInText]);

  React.useEffect(() => {
    const stateMap = {
      [Button.State.unknown]: ["Loading", null],
      [Button.State.loggedInNonMember]: [loggedInNonMemberText, loggedInNonMemberUrl],
      [Button.State.loggedInMember]: [loggedInText, loggedInUrl],
      [Button.State.loggedOut]: [loggedOutText, loggedOutUrl],
    };

    const [text, url] = stateMap[userState] || [loggedOutText, loggedOutUrl];

    setLinkText(safeValue(text, loggedOutText));
    setLinkUrl(safeValue(url, loggedOutUrl));
  }, [programID, userState, loggedOutText, loggedInNonMemberText, loggedInText]);

  if (userState == Button.State.unknown) {
    return null;
  }

  return (
    <Link
      text={linkText}
      url={linkUrl}
      classes={classNames(variant, size)}
      target={target(openInNewTab)}
    />
  );
}
